import React, { useEffect } from "react";
import { Snackbar, Alert, Box, Avatar, Typography } from "@mui/material";
import { useSelector, useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { hideNotification } from "../../../services/store/slice/NotificationSlice";
import {
  resetUnreadCount,
  setChat_Id,
  setConvoType,
  setSelectedContactName,
  setSelectedContactProfileImage,
  setUserId,
} from "../../../services/store/slice/ChatSlice";
import { settings as s } from "../../../services/Settings";
import addNotification from "react-push-notification";
import avatarImg from "../../../../assets/img/Avatar.png";
import groupImg from "../../../../assets/img/Group.png";
import { setNewTasksNotification } from "../../../services/store/slice/TaskAndTicket";

const Notification = () => {
  const userId = localStorage.getItem("user_id");
  const dispatch = useDispatch();
  const navigate = useNavigate(); // Hook for navigation
  const { open, message, chatId } = useSelector((state) => state.notification);
  const chat_Id = useSelector((state) => state.chat.chat_Id);
  const { newTasksNotification, existingTask, tasksInBoardView } = useSelector(
    (state) => state.taskAndTicket
  );

  const handleClose = () => {
    dispatch(hideNotification());
  };

  const handleClick = () => {
    dispatch(hideNotification());
    if (chatId !== null) {
      // localStorage.setItem("chatIdLS", chatId)
      // dispatch(setChat_Id(chatId));
      navigate(`/chats`);
    } else {
      navigate("/chats");
    }
  };

  // handle Notification Fun
  const handleNotifyFun = (message) => {
    addNotification({
      title: message?.name
        ? `${message?.name}`
        : message?.senderNo
        ? `${message?.senderNo}`
        : message?.admin
        ? `${message?.admin?.firstName} ${message?.admin?.lastName} added you to "${message?.name}"`
        : message?.chat?.conversationType === "Group"
        ? `${message?.senderName} in "${message?.chat?.name}"`
        : message?.senderName,
      message:
        message?.attachments?.length > 0
          ? "Attachment"
          : message?.messageContent,
      theme: "dark",
      position: "bottom-left",
      duration: 10000,
      icon: (() => {
        // handle Add Participant Notification
        if (message?.conversationType === "Group") {
          if (message?.picPath) {
            return `${s.baseUrl}${message?.picPath}`;
          }
          return groupImg;
        }

        // Handle group picture -- group conversation
        if (message?.chat?.conversationType === "Group") {
          if (message?.chat?.picPath) {
            return `${s.baseUrl}${message?.chat?.picPath}`;
          }
          return groupImg; // Default to group image if no chat image
        }

        // For sender's profile picture -- single conversation
        if (message?.chat?.conversationType === "Single") {
          if (message?.senderProfilePic) {
            return `${s.baseUrl}${message?.senderProfilePic}`;
          }
          return avatarImg;
        }
      })(),
      native: true,
      onClick: () => {
        if (message?.chat?.conversationType === "Single") {
          dispatch(setChat_Id(chatId));
          dispatch(setSelectedContactName(message?.senderName));
          dispatch(setSelectedContactProfileImage(message?.senderProfilePic));
          dispatch(setConvoType("Single"));
          dispatch(setUserId(message?.senderId));
          localStorage.setItem("otherUserId", message?.senderId);
          localStorage.setItem("picPath", message?.senderProfilePic);
          localStorage.setItem("chatId", chatId);
          localStorage.setItem("convoType", "Single");
          localStorage.setItem("selectedContactName", message?.senderName);
          navigate(`/chats`);
          dispatch(
            resetUnreadCount({
              chatId: chatId,
              ishide: null,
            })
          );
          window.moveTo(500, 100);
          window.focus();
        } else if (message?.conversationType === "Group") {
          dispatch(setChat_Id(message?.chatId));
          dispatch(setSelectedContactName(message?.name));
          dispatch(setSelectedContactProfileImage(message?.picPath));
          dispatch(setConvoType("Group"));
          dispatch(setUserId(message?.senderId));
          localStorage.setItem("otherUserId", message?.senderId);
          localStorage.setItem("picPath", message?.picPath);
          localStorage.setItem("chatId", message?.chatId);
          localStorage.setItem("convoType", "Group");
          localStorage.setItem("selectedContactName", message?.name);
          navigate(`/chats`);
          dispatch(
            resetUnreadCount({
              chatId: message?.chatId,
              ishide: null,
            })
          );
          window.moveTo(500, 100);
          window.focus();
        } else {
          dispatch(
            setChat_Id(
              message?.chat?.chatId
                ? message?.chat?.chatId
                : message?.conversationId
            )
          );
          dispatch(
            setSelectedContactName(
              message?.chat?.name ? message?.chat?.name : message?.senderNo
            )
          );
          dispatch(
            setSelectedContactProfileImage(
              message?.chat?.picPath ? message?.chat?.picPath : ""
            )
          );
          dispatch(setUserId(message?.senderId ? message?.senderId : ""));
          localStorage.setItem(
            "otherUserId",
            message?.senderId ? message?.senderId : ""
          );
          dispatch(setConvoType("Group"));
          localStorage.setItem(
            "picPath",
            message?.chat?.picPath ? message?.chat?.picPath : ""
          );
          localStorage.setItem(
            "chatId",
            message?.chat?.chatId
              ? message?.chat?.chatId
              : message?.conversationId
          );
          localStorage.setItem("convoType", "Group");
          localStorage.setItem(
            "selectedContactName",
            message?.chat?.name ? message?.chat?.name : message?.senderNo
          );
          navigate(`/chats`);
          dispatch(
            resetUnreadCount({
              chatId: message?.chat?.chatId
                ? message?.chat?.chatId
                : message?.conversationId,
              ishide: null,
            })
          );
          window.moveTo(500, 100);
          window.focus();
        }
      },
    });
  };

  const getChatAlert = () => {
    if (open) {
      handleNotifyFun(message || []);
      dispatch(hideNotification());
    }
  };

  useEffect(() => {
    getChatAlert();
  }, [message?.senderId, chatId, userId, chat_Id]);

  // const handleTaskNotification = (task) => {
  //   console.log(task,"tasknotification")
  //   addNotification({
  //     title: `${newTasksNotification?.userName} ${
  //       existingTask ? "Change Status" : "Assigned Task"
  //     } `,
  //     message: existingTask ? task?.status : task?.taskTitle,
  //     theme: "dark",
  //     position: "bottom-right",
  //     duration: 8000,
  //     icon: (() => {
  //       if (task.assignedBy?.profilePicPath) {
  //         return `${s.baseUrl}${task.assignedBy?.profilePicPath}`;
  //       }
  //       return avatarImg;
  //     })(),
  //     native: true,
  //     onClick: () => {
  //       navigate("/tasks");
  //     },
  //   });
  //   dispatch(
  //     setNewTasksNotification({
  //       pending: [],
  //       notStarted: [],
  //       inProcess: [],
  //       completed: [],
  //     })
  //   );
  // };

  const stripHtml = (html) => {
    const tmp = document.createElement("div");
    tmp.innerHTML = html;
    return tmp.textContent || tmp.innerText || "";
  };

  const handleTaskNotification = (task) => {
    const status = task?.status || "Unknown Status";
    const dueDate = task?.daysLeft || "No DueDays";
    const priority = task?.priority || "Normal";
    const getStatusIcon = (status) => {
      switch (status?.toLowerCase()) {
        case "notstarted":
          return "🔘";
        case "inprocess":
          return "🟡";
        case "completed":
          return "✅";
        case "pending":
          return "🟡";
        default:
          return "🕓";
      }
    };

    // const currentUserId = parseInt(userId);

    // const notifyUserId = task?.assignedBy?.userId;
    //       console.log(notifyUserId,'notifyuser');
    //   if (task?.assigned_To?.userId === currentUserId) {
    //       if (notifyUserId) {

    addNotification({
      title: `${newTasksNotification?.userName} ${
        existingTask ? "Changed Task Status" : "Assigned You a Task"
      }`,
      message: `
📝 Task: ${task?.taskTitle}
📅 DueDays: ${dueDate}
📌 Priority: ${priority} 
${getStatusIcon(status)} Status: ${
        status?.toLowerCase() === "notstarted"
          ? "Not Started"
          : status?.toLowerCase() === "inprocess"
          ? "In Process"
          : status
      }
    `.trim(),
      theme: "dark",
      position: "bottom-right",
      duration: 8000,
      icon: (() => {
        if (task.assignedBy?.profilePicPath) {
          return `${s.baseUrl}${task.assignedBy?.profilePicPath}`;
        }
        return avatarImg;
      })(),
      native: true,
      onClick: () => {
        navigate("/tasks");
      },
    });

    dispatch(
      setNewTasksNotification({
        pending: [],
        notStarted: [],
        inProcess: [],
        completed: [],
      })
    );
  };
  // }
  // }

  useEffect(() => {
    if (newTasksNotification) {
      if (newTasksNotification?.completed?.length > 0) {
        return newTasksNotification?.completed?.forEach((task) => {
          handleTaskNotification(task);
        });
      }

      if (newTasksNotification?.inProcess?.length > 0) {
        return newTasksNotification?.inProcess?.forEach((task) => {
          handleTaskNotification(task);
        });
      }

      if (newTasksNotification?.notStarted?.length > 0) {
        return newTasksNotification?.notStarted?.forEach((task) => {
          handleTaskNotification(task);
        });
      }

      if (newTasksNotification?.pending?.length > 0) {
        return newTasksNotification?.pending?.forEach((task) => {
          handleTaskNotification(task);
        });
      }
    }
  }, [newTasksNotification]);
  return (
    <Snackbar
      // open={open}
      open={false}
      autoHideDuration={4000}
      onClose={handleClose}
      anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
    >
      <Alert
        onClose={handleClose}
        severity={"info"}
        variant="filled"
        icon={false}
        sx={{
          width: "100%",
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          bgcolor: "gray",
          cursor: "pointer",
        }}
      >
        <Box
          display={"flex"}
          alignItems={"center"}
          onClick={() => {
            handleClick();
          }}
        >
          <Avatar
            src={`${s?.baseUrl}/${message?.senderProfilePic}`}
            alt={message[0]?.senderName}
            sx={{
              marginRight: 2,
              width: { md: "35px", xs: "35px" },
              height: { md: "35px", xs: "35px" },
            }}
          />

          <Box>
            <Typography sx={{ fontSize: "12px" }}>
              {message?.senderName}
            </Typography>
            <Typography sx={{ fontSize: "12px" }}>
              {message?.messageContent?.length > 12
                ? message?.messageContent?.slice(0, 12) + "..."
                : message?.messageContent}
            </Typography>
          </Box>
        </Box>
      </Alert>
    </Snackbar>
  );
};

export default Notification;
